import categories from './categories.json';
import messageRequest from './message-request.json';
import home from './home.json';
import address from './address.json';
import common from './common.json';
import store from './store.json';
import payment from './payment.json';
import panther from './panther.json';
import event from './event.json';
import promotion from './promotion.json';
import alert from './alert.json';

export default {
  categories,
  messageRequest,
  home,
  address,
  common,
  store,
  payment,
  panther,
  event,
  promotion,
  alert,
};
